<div class="ribbon"></div>

<!-- vertically center if body is not present (only title is present) -->
<!-- else move to top, right 16px each -->
<va-icon
  class="close-btn"
  size="small"
  name="close"
  [style.vertical-align]="body == null && 'middle'"
  [style.top]="body != null && '16px'"
  (click)="destroyModal()"
>
</va-icon>

<div class="data-container">
  <div class="icon-container">
    <!-- Todo test this icon usage -->
    <va-icon [isFontAwesome]="true" [name]="icon" ></va-icon>
  </div>

  <div class="text-container">
    <h1 class="title">{{ title }}</h1>
    <p class="body" *ngIf="body != null" [innerHTML]="body"></p>
  </div>
</div>

<div class="dialog-actions">
  <a
    *ngIf="actionSecondaryText && onSecondaryClick != null"
    nz-button
    nzType="link"
    class="action-secondary"
    (click)="onSecondaryClick()"
  >
    {{ actionSecondaryText }}
  </a>
  <button
    *ngIf="actionthirdText && onThirdClick != null"
    nz-button
    class="third-btn"
    (click)="onThirdClick()"
  >
    {{ actionthirdText }}
  </button>
  <button
    *ngIf="actionPrimaryText && onPrimaryClick != null"
    nz-button
    nzType="primary"
    [ngClass]="actionthirdText ? '' : 'action-primary'"
    (click)="onPrimaryClick()"
  >
    {{ actionPrimaryText }}
  </button>
</div>
